export default "__VITE_ASSET__b7452c77__"